module.exports = __webpack_public_path__ + "static/media/m4k15.63bcb439.png";